module.exports = __webpack_public_path__ + "static/media/taggis-and-docbrowser.29c15097.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/taggis-and-docbrowser.png
// module id = 372
// module chunks = 3